<!-- 学校信息对比 -->
<template>
  <div class="index">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>

    <div class="block_red flex-col">
    </div>
    <div class="block_qie flex-row">
      <div class="main">
        <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge73d4969448c0c099997a3e563ebf3a5d02171a1afdf68465ddec07eff136eba"
          />
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
        />
        <span class="text_13" @click="back()">返回首页</span>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
        />
        <span class="text_14">学校对比</span>
      </div>
    </div>
    <div class="justify-center">
      <table
        id="table"
        border="1"
        cellspacing="0"
        width="1300"
        bgcolor="slategray "
      >
        <tr style="text-align: left; height: 50px ;" >
          <span style=" font-size: 20px; margin: 20px"
            >学校信息对比 </span
          ><br><span style="color: red;margin: 10px">最多可比对4个学校</span>
        </tr>
        <tr
          v-for="(key, value, index1) in SchoolComparisondist"
          :key="index1"
          :class="'tr_' + (index1 + 1)"
          v-show="!(value == 'id' || value == 'tb_school_img')"
        >
          <td
            v-for="(item, index) in SchoolComparisonList"
            :key="index"
            :class="'td_' + (index + 1)"
            v-show="index < 5"
          >
            <div v-if="value == 'tb_school_uuid' || value == 'tb_school_name'">
              <div v-if="value == 'tb_school_uuid'">
                <div
                  v-if="
                    !(
                      item.tb_school_img == '+' ||
                      item.tb_school_img == '学校图片'
                    )
                  "
                  style="width: 100%; height: 200px"
                >
                  <div
                    style="padding: 0px 0px 0px 90%; height: 28px"
                    @click="del_school(item[value])"
                  >
                    x
                  </div>
                  <img
                    style="width: 148px; height: 120px; margin: 3px"
                    :src="'api' + item.tb_school_img"
                  />
                </div>

                <div v-if="item.tb_school_img == '学校图片'">
                  {{ item.tb_school_img }}
                </div>
                <div v-else-if="item.tb_school_img == '+'" class="buts" @click="append()">
                  <img
                    style="width: 50px; height: 50px; margin: 3px"
                    src="../../static/img/添加学校.png"
                  />
                </div>
              </div>
              <div
                v-else-if="
                  item.tb_school_name == '+' && value == 'tb_school_name'
                "
              >
                <!-- {{ item.tb_school_name }} -->
              </div>
              <div v-else>
                {{ item[value] }}
              </div>
            </div>

            <div v-else>
              {{ item[value] }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 添加学校模态框 -->
    <div class="scbox_13 flex-col" v-show="schoollie">
      <div class="scsection_2 flex-col">
        <div class="scsection_3 flex-row">
          <div class="scgroup_21 flex-row">
            <img
              class="sclabel_1"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng29967d4c076282b434ee1de68f62985616a9e7f9e14ad32a6c9e6ca706c538e2"
            />
            <span class="sctext_32">学校列表</span>
            <div class="scblock_3 flex-col"></div>
          </div>
          <span class="sctext_33">学校の一覧です</span>
          <span class="sctext_34 buts" @click="school()">确定</span>
        </div>
        <div class="scsection_4 flex-row justify-between">
          <el-cascader
            class="scgroup_231"
            v-model="schoollist"
            :options="yjlist"
            :props="props"
            :show-all-levels="false"
            collapse-tags
            collapse-tags-tooltip
            max-collapse-tags="3"
            filterable
            clearable
            @change="lookschool()"
          />
          <div class="scgroup_23 flex-row">
            <el-select
              v-model="teg_value"
              placeholder="请选择"
              clearable
              @change="teg_change()"
              style="height: 42px;"
            >
              <el-option
                v-for="(item, index) in optionTs"
                :key="index"
                :label="item.tb_name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="width: 300px; height: 40px; ">
            <el-row>
              <el-col style="width: 270px; height: 40px; ">
                <el-input
                  type="text"
                  class="el-input"
                  prefix-icon="el-icon-search"
                  v-model="keywords"
                  placeholder="搜索学院关键词"
                  style="width: 270px;height: 40px; "
                  @keyup.enter.native="getAllKb"
                ></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="elemsousuo" @click="search()">搜索</div>
        </div>
        <div style="height: 500px; overflow-x: hidden">
          <div
            class="scsection_5 flex-row"
            v-for="(item, index) in schoolLlist"
            :key="index"
          >
            <div class="scimage-text_1 flex-row justify-between">
              <div class="scsection_6 flex-col">
                <img
                  style="width: 140px; height: 140px;"
                  :src="'api' + item.tb_school_img"
                  alt=""
                />
              </div>
              <div class="sctext-group_1 flex-col">
                <span class="sctext_39">{{ item.tb_school_name }}</span>
                <span class="sctext_40">{{ item.tb_school_name }}</span>
                <div class="sctext-wrapper_12 flex-row justify-between">
                  <span class="sctext_41">学校属性：</span>
                  <span class="sctext_42">{{ item.tb_school_sx }}</span>
                </div>
                <div class="sctext-wrapper_13 flex-row justify-between">
                  <span class="sctext_43">所在地区：</span>
                  <span class="sctext_44">{{ item.tb_school_address }}</span>
                </div>
              </div>
            </div>
            <span class="sctext_45">建校时间：</span>
            <span class="sctext_46">学费：</span>
            <span class="sctext_47">{{ item.tb_school_time }}</span>
            <span class="sctext_48">{{ item.tb_school_xuefei }}</span>
            <span class="sctext_49">学校定员：</span>
            <span class="sctext_50">{{ item.tb_school_dingyuan }}</span>
            <div class="scimage-text_2 flex-row justify-between">
              <el-checkbox
                v-model="listDb"
                :label="item.tb_school_uuid"
                :max="4"
                >学校对比</el-checkbox
              >
            </div>
            <!-- <div class="scsection_7 flex-col"></div> -->
          </div>
        </div>

        <div class="scsection_12 flex-row justify-between">
          <div class="box_70 flex-col justify-between">
            <div class="block_13 flex-col"></div>
            <el-pagination
              layout="prev, pager, next"
              limit="10"
              :total="total"
              :prev-text="'上一页'"
              :next-text="'下一页'"
              @current-change="handleCurrentChange"
            >
              >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <my_article></my_article>
    <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="100%"
      :before-close="handleClose"
    >
      <video :src="videoSrc" controls="controls" autoplay>
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog> -->
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetSchoolCha } from "../api/schoolcha";
import { GetSchoolTeg } from "../api/school";
import { GetSchoolComparison } from "../api/SchoolComparison";
import { GeRmAddress } from "../api/index";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article
  },
  data() {
    return {
      schoollie: false,
      optionsDq: [], //地区选择
      schoolLlist: [], //学校列表
      optionTs: [], //特色选择
      address_value: "", //地区
      teg_key: "",
      teg_value: "", //特色
      keywords: "", //搜索关键词
      limit: 10, //一页显示条数
      page: 1, //页面下标
      checkList: [], //选中学校
      listA: [],
      listDb: [], //学校对比接口中使用的参数
      SchoolComparisonList: [],
      SchoolComparisondist: {},
      tb_uuid_list: "",
      img_show: false,
      currentPage: 1,
      total: 0, //总数
      limit: 10,
      page: 1,
      schoollist:[],
      yjlist: [],
      fenyemomo: false,
      typelook: false,
      props: { multiple: true, checkStrictly: true }
    };
  },
  created() {
    this.getschoolcha();
    this.getschoolteg();
    this.schoolguolv();
    this.getschooltegts();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
    // this.getSchoolComparison();
    // console.log(this.$route.query.id)
    if (this.$route.query.id) {
      this.listDb.push(this.$route.query.id);
      this.getSchoolComparison();
    } else {
      this.getSchoolComparison();
    }
  },
  methods: {
    lookschool(val) {
      
      this.fenyemomo = true;
      this.address_value = "";
      this.teg_value = "";
      GetSchoolCha({
        limit: this.limit,
        page: val,
        teg_key: "",
        addresslist: this.schoollist,
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.total = response.data.address_json.address_count;
      });
    },
    schoolguolv() {
      GeRmAddress({ is_tree: true }).then(response => {
        this.yjlist = response.data; //城市
      });
    },
    // 删除对比学校
    del_school(value) {
      var index = this.listDb.findIndex(item => {
        if (item == value) {
          return true;
        }
      });
      this.listDb.splice(index, 1);
      this.getSchoolComparison();
      // console.log(index,this.listDb)
    },
    // 鼠标移入触发事件
    mousemove() {
      this.img_show = true;
    },
    // 鼠标移出触发事件
    mouseleave() {
      this.img_show = false;
    },
    // 特色标签值修改后触发方法
    teg_change(val) {
      this.typelook = true;
      this.page = val;
      this.schoollist = [];
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: "特色",
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.total = response.data.address_json.address_count;
      });

      // console.log(this.address_value, this.teg_key, this.teg_value);
    },
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    bofang(item) {
      this.dialogVisible = true;
      this.videoSrc = item;
    },
    handleClose(done) {
      done();
    },
    //搜索
    search() {
      this.getschoolcha();
    },
    //学校列表
    getschoolcha() {
      // let limit = this.limit; //一页显示条数
      // let page = this.page; //页面下标
      // let teg_value = ""; //标签选择
      // let address_value = ""; //地图区域选择
      // let teg_key = this.teg_key; //区域
      let keywords = this.keywords; //关键字查询
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: this.teg_key,
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value,
        keywords
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.total = response.data.address_json.address_count;
      });
    },
    //地区
    getschoolteg() {
      let teg_key = "地区"; //地区
      GetSchoolTeg({ teg_key }).then(response => {
        this.optionsDq = response.data;
        // console.log(this.optionsDq, "标签");
      });
    },
    //特色
    getschooltegts() {
      let teg_key = "特色"; //特色
      GetSchoolTeg({ teg_key }).then(response => {
        this.optionTs = response.data;
        // console.log(this.optionTs, "标签");
      });
    },
    //选中学校返回数据
    getSchoolComparison() {
      GetSchoolComparison({ tb_uuid_list: this.listDb }).then(response => {
        this.SchoolComparisonList = response.data;
        this.SchoolComparisondist = response.data[0];
        // console.log(this.SchoolComparisonList, "选中学校");
        // console.log(this.SchoolComparisonList[0], "下标0");
      });
    },
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    //点击确定
    school() {
      if (this.listDb.length > 4) {
        this.$message({
          message: "学校对比最多选四所学校对比",
          type: "warning"
        });
        return;
      }
      this.schoollie = false;
      this.getSchoolComparison();
    },
    //打开对比学校模态框
    append() {
      this.schoollie = true;
    },
    handleCurrentChange(val) {
      if (this.fenyemomo) {
        this.lookschool(val);
        return;
      }
      if (this.typelook) {
        this.teg_change(val);
        return;
      }
      this.page = val;
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: this.teg_key,
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.total = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
        console.log(this.total);
      });
    }
  }
};
</script>
<style src="../../static/css/answers.css" scoped />

<style scoped>
.tr_2 >>> [class*="td_"] {
  width: 270px;
  height: 200px;
  background: #ffffff;
  border: 1px solid #dddddd;
}
.tr_3 >>> [class*="td_"] {
  background: #eeeeee;
}

.td_1 {
  width: 120px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #dddddd;
}
.td_2 {
  width: 260px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #dddddd;
}
.td_3 {
  width: 260px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #dddddd;
}
.td_4 {
  width: 260px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #dddddd;
  margin-top: -5px;
  margin-left: -5px;
}
.td_5 {
  width: 260px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #dddddd;
}
.article {
  display: flex;
  justify-content: center;
}

.link {
  display: flex;
  justify-content: center;
}
.elemsousuo {
  width: 70px;
  height: 42px;
  background: red;
  margin-left: 50px;
  margin-top: -60px;
  line-height: 42px;
  font-size: 22px;
  color: #ffffff;
  cursor: pointer;
  margin: 0;
}
/* .el-input__inner {
    padding-right: 30px;
    height: 48px !important;
} */
</style>



// WEBPACK FOOTER //
// src/page/answers.vue